// extracted by mini-css-extract-plugin
export default {"requiere":"Valida_requiere__1R7qm"};